/* JANUS countdown: runs to "Doors open" (UK time) from Theme settings → Next event.
   Each digit that changes glitches in; every 10 seconds the whole row "rewinds".
   States are put on the nearest [data-event] wrapper so buttons can show/hide:
   data-state="soon" | "live" | "over" | "none". */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // "2026-11-06 23:00" in London -> UTC milliseconds (handles GMT/BST)
  function london(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
      var p = {}; f.formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = x.value; });
      var asLondon = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
      return guess - (asLondon - guess);
    } catch (e) { return guess; }
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init(el) {
    var start = london(el.getAttribute('data-start')), end = london(el.getAttribute('data-end'));
    if (isNaN(end)) end = start + 7 * 3600000;
    var host = el.closest('[data-event]') || el.parentNode;
    var row = el.querySelector('[data-cd-row]'), live = el.querySelector('[data-cd-live]'), after = el.querySelector('[data-cd-after]');
    var cells = {}; el.querySelectorAll('[data-u]').forEach(function (c) { cells[c.getAttribute('data-u')] = c; });
    var last = {}, flip = {};
    function state(s) { if (host.getAttribute('data-state') !== s) host.setAttribute('data-state', s); }
    function tick() {
      var now = Date.now();
      if (isNaN(start)) { row.hidden = true; live.hidden = true; after.hidden = false; state('none'); return; }
      if (now >= end) { row.hidden = true; live.hidden = true; after.hidden = false; state('over'); return; }
      if (now >= start) { row.hidden = true; live.hidden = false; after.hidden = true; state('live'); return; }
      row.hidden = false; live.hidden = true; after.hidden = true; state('soon');
      var t = Math.floor((start - now) / 1000);
      var v = { d: Math.floor(t / 86400), h: Math.floor(t % 86400 / 3600), m: Math.floor(t % 3600 / 60), s: t % 60 };
      for (var k in v) {
        var txt = pad(v[k]);
        if (last[k] === txt || !cells[k]) continue;
        cells[k].textContent = txt;
        if (!reduce && last[k] !== undefined) { flip[k] = !flip[k]; cells[k].classList.remove('g-a', 'g-b'); void cells[k].offsetWidth; cells[k].classList.add(flip[k] ? 'g-a' : 'g-b'); }
        last[k] = txt;
      }
      if (!reduce && v.s % 10 === 0) { row.classList.remove('rw'); void row.offsetWidth; row.classList.add('rw'); }
    }
    tick();
    setInterval(tick, 1000);
  }
  function boot() { document.querySelectorAll('[data-countdown]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
